/* @flow */
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import TitleHeader from 'components/TitleHeader.jsx';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupStore from 'groups/stores/GroupStore';
import GroupName from 'groups/components/GroupName.jsx';
import SchoolPicker from 'components/SchoolPicker.jsx';
import AffiliationStore from 'stores/AffiliationStore';
import Text from 'components/Text.jsx';
import { UNAFFILIATED } from 'constants/OrganizationConstants';

import './styles/TeacherInfoCollection.scss';

const SCREEN_NAME = 'teacher_info_collection';

class TeacherInfoCollection extends React.Component {
  static childContextTypes = {
    eventScreenName: React.PropTypes.string,
  };

  getChildContext() {
    return {
      eventScreenName: SCREEN_NAME,
    };
  }

  selectSchool(group: Group, organizationId: ?number) {
    GroupActions.patch(group, { organization_id: organizationId });
  }

  renderTableHeader() {
    return (
      <tr>
        <th>Class</th>
        <th>Class is at</th>
        <th>Grade(s)</th>
        <th>Subject</th>
      </tr>
    );
  }

  renderTableRow(group: Group) {
    const schoolSuggestions = AffiliationStore.getMemberOrganizations();
    if (!group.hasChildren()) {
      schoolSuggestions.push(UNAFFILIATED);
    }
    return (
      <tr key={group.id}>
        <th>
          <GroupAvatar group={group} size="small" />
          <Text className="TeacherInfoCollection-groupName" truncate>
            <GroupName group={group} />
          </Text>
        </th>
        <th>
          <SchoolPicker
            onSelect={this.selectSchool.bind(this, group)}
            onClear={() => {}}
            suggestions={schoolSuggestions}
            selectedSchool={group.getOrganization() || UNAFFILIATED}
          />
        </th>
        <th />
        <th />
      </tr>
    );
  }

  renderTable() {
    const groups = GroupStore.getOwnedGroups().map(group => this.renderTableRow(group));
    return (
      <table className="TeacherInfoCollection-table">
        <thead>{this.renderTableHeader()}</thead>
        <tbody>{groups}</tbody>
      </table>
    );
  }

  render() {
    return (
      <BoxBody>
        <TitleHeader
          title="Update your class information"
          subtext="Make sure you have the correct school, grade and subject for each class"
        />
        {this.renderTable()}
      </BoxBody>
    );
  }
}

export default TeacherInfoCollection;




// WEBPACK FOOTER //
// ./src/user/components/TeacherInfoCollection.jsx